import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-email-preview',
  standalone: true,
  imports: [],
  templateUrl: './email-preview.component.html',
  styleUrl: './email-preview.component.css'
})
export class EmailPreviewComponent {
  private _html = '';
  private possuiPosicaoAnterior = false;
  private scrollTopAnterior = 0;
  private estavaNoFim = false;
  htmlSeguro: SafeHtml = '';

  @Input() blocoAlvoId?: string;
  @ViewChild('previewFrame') previewFrame?: ElementRef<HTMLIFrameElement>;

  @Input() set html(valor: string | undefined) {
    this.capturarPosicaoAtual();
    this._html = valor ?? '';
    this.htmlSeguro = this.sanitizer.bypassSecurityTrustHtml(this._html);
  }
  get html(): string {
    return this._html;
  }

  private readonly sanitizer = inject(DomSanitizer);

  aoCarregar(): void {
    requestAnimationFrame(() => this.restaurarPosicao());
  }

  private capturarPosicaoAtual(): void {
    const janela = this.previewFrame?.nativeElement.contentWindow;
    const documento = janela?.document;
    const scroll = documento?.scrollingElement;
    if (!janela || !scroll) {
      return;
    }

    const maximo = Math.max(0, scroll.scrollHeight - janela.innerHeight);
    this.scrollTopAnterior = janela.scrollY;
    this.estavaNoFim = maximo - janela.scrollY <= 24;
    this.possuiPosicaoAnterior = true;
  }

  private restaurarPosicao(): void {
    const janela = this.previewFrame?.nativeElement.contentWindow;
    const documento = janela?.document;
    const scroll = documento?.scrollingElement;
    if (!janela || !documento || !scroll) {
      return;
    }

    const blocoAlvo = this.blocoAlvoId
      ? Array.from(documento.querySelectorAll<HTMLElement>('[data-email-block-id]'))
          .find(elemento => elemento.dataset['emailBlockId'] === this.blocoAlvoId)
      : undefined;

    if (blocoAlvo) {
      const retangulo = blocoAlvo.getBoundingClientRect();
      const topo = janela.scrollY + retangulo.top;
      const destino = Math.max(0, topo - Math.max(12, (janela.innerHeight - retangulo.height) / 2));
      janela.scrollTo({ top: destino, behavior: 'auto' });
      return;
    }

    if (!this.possuiPosicaoAnterior) {
      return;
    }

    const maximo = Math.max(0, scroll.scrollHeight - janela.innerHeight);
    janela.scrollTo({
      top: this.estavaNoFim ? maximo : Math.min(this.scrollTopAnterior, maximo),
      behavior: 'auto'
    });
  }
}
